<script>
    import {createEventDispatcher} from 'svelte/internal';
    import {pad0} from "../js/utils";
    import Icon from "../components/icons/Icon.svelte";


    export let date = null;
    export let startDate = '';
    export let hideToday = false;
    export let hideClear = false;

    const weekDays = ['MO', 'TU', 'WE', 'TH', 'FR', 'SA', 'SU'];
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

    let calendar = [];
    let calendarDate = '';
    let calendarMonth = 0;
    let calendarYear = 0;

    let showMonths = false;
    let showYears = false;

    const dispatch = createEventDispatcher();

    const parseLocalYMD = (ymd) => {
    const [y, m, d] = ymd.split('-').map(Number);
    return new Date(y, m - 1, d);
};

    const getDaysInMonth = (month, year) => {
        // Here January is 1 based
        //Day 0 is the last day in the previous month
        return new Date(year, month, 0).getDate();
    };

    const stepMonth = (year, month, step) => {
        let m = month + step;
        let y = year;
        if (m > 12) {
            m = 1;
            y++;
        } else if (m < 1) {
            m = 12;
            y--;
        }

        return [y, m];
    }

    const setCalendar = () => {
        let monthDays = 0;
        let prevMonthDays = 0;
        calendar = [];

        monthDays = getDaysInMonth(calendarMonth, calendarYear);
        prevMonthDays = getDaysInMonth(calendarMonth - 1, calendarYear);
        let [previousYear, previousMonth] = stepMonth(calendarYear, calendarMonth, -1);
        let [nextYear, nextMonth] = stepMonth(calendarYear, calendarMonth, 1);

        let d = 0;
        // let firstWeekDay = new Date(`${calendarYear}-${pad0(calendarMonth)}-01`).getDay() - 1; // 6 - Saturday
        let firstWeekDay = new Date(calendarYear, calendarMonth - 1, 1).getDay() - 1;
        if (firstWeekDay < 0) {
            firstWeekDay = 6;
        }
        let date = '';
        // previous month
        d = prevMonthDays - firstWeekDay + 1;
        for (let index = 0; index < firstWeekDay; index++) {
            date = `${previousYear}-${pad0(previousMonth)}-${pad0(d)}`;
            calendar.push({
                day: d,
                active: false,
                disabled: date < startDate,
                date
            });
            d++;
        }
        // current month
        for (d = 1; d <= monthDays; d++) {
            date = `${calendarYear}-${pad0(calendarMonth)}-${pad0(d)}`;
            calendar.push({
                day: d,
                active: date >= startDate,
                disabled: date < startDate,
                date
            });
        }
        // next month
        if (calendar.length % 7 > 0) {
            let daysToAdd = 7 - (calendar.length % 7);
            for (let d = 1; d <= daysToAdd; d++) {
                date = `${nextYear}-${pad0(nextMonth)}-${pad0(d)}`;
                calendar.push({
                    day: d,
                    active: false,
                    disabled: date < startDate,
                    date
                });
            }
        }
    }

    const previousMonth = () => {
        showMonths = false;
        showYears = false;
        calendarMonth--;
        if (calendarMonth < 1) {
            calendarYear--;
            calendarMonth = 12;
        }
        setCalendar();
    }

    const nextMonth = () => {
        showMonths = false;
        showYears = false;
        calendarMonth++;
        if (calendarMonth > 12) {
            calendarYear++;
            calendarMonth = 1;
        }
        setCalendar();
    }

    const selectDate = (day) => {
        if (day.disabled) {
            return;
        }

        calendarDate = day.date;
        date = day.date;
        dispatch('change', date);
    }

    const selectToday = () => {
        let dt = new Date();
        calendarMonth = dt.getMonth() + 1;
        calendarYear = dt.getFullYear();
        calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;
        date = calendarDate;
        setCalendar();
        dispatch('change', date);
    }

    const clearDate = () => {
        date = null;
        calendarDate = null;
        dispatch('change', date);
    }

    const toggleMonthSelector = () => {
        showMonths = !showMonths;
        showYears = false;
    }

    const toggleYearSelector = () => {
        showMonths = false;
        showYears = !showYears;
    }

    const selectMonth = month => {
        showMonths = false;
        calendarMonth = month + 1;
        setCalendar();
    }

    const selectYear = year => {
        showYears = false;
        calendarYear = year;
        setCalendar();
    }


    // const initialize = () => {
    //     let dt;
    //     if (!date) {
    //         dt = new Date();
    //     } else {
    //         dt = new Date(date);
    //     }
    //
    //     calendarMonth = dt.getMonth() + 1;
    //     calendarYear = dt.getFullYear();
    //     calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;
    //
    //     setCalendar();
    // }

    const initialize = () => {
    let dt;

    if (!date) {
        dt = new Date();
    } else {
        dt = parseLocalYMD(date);
    }

    calendarMonth = dt.getMonth() + 1;
    calendarYear = dt.getFullYear();
    calendarDate = `${dt.getFullYear()}-${pad0(dt.getMonth() + 1)}-${pad0(dt.getDate())}`;

    setCalendar();
};

    initialize();

    $: if (date != calendarDate) {
        initialize();
    }
</script>

<div class="calendar-control">
    <div class="heading">
        <button type="button" class="month-nav" on:click="{ previousMonth }">
            <Icon name="chevron-left" strokeWidth="2"/>
        </button>
        <div class="title">
            <button type="button" class="title-link ps-2 pe-1" on:click={ toggleMonthSelector }>
                { months[calendarMonth - 1] }
            </button>
            <button type="button" class="title-link ps-1 pe-2" on:click={ toggleYearSelector }>{ calendarYear }</button>
        </div>
        <button type="button" class="month-nav" on:click="{ nextMonth }">
            <Icon name="chevron-right" strokeWidth="2"/>
        </button>
    </div>
    <div class="body">
        {#if showMonths}
            <div class="month-selector">
                {#each months as monthName, index}
                    <button type="button" class="btn btn-link" on:click={ () => selectMonth(index) }>{ monthName }</button>
                {/each}
            </div>
            {:else if showYears}
            <div class="year-selector">
                {#each Array(12) as dummy, index}
                    <button type="button" class="btn btn-link" on:click={ () => selectYear(index + 2020) }>{ index + 2020 }</button>
                {/each}
            </div>
        {:else}
            {#each weekDays as wDay}
                <div class="weekday">
                    { wDay }
                </div>
            {/each}
            {#each calendar as day}
                <button type="button" class="day" class:active={ day.active } class:selected="{ day.date === calendarDate }"
                     on:click="{ () => selectDate(day) }" disabled={day.disabled}>
                    { day.day }
                </button>
            {/each}
        {/if}
    </div>
    {#if !hideToday || !hideClear}
        <div class="footer">
            {#if !hideToday}
                <button type="button" class="btn btn-link" on:click="{ selectToday }">today</button>
            {/if}
            {#if !hideClear}
                <button type="button" class="btn btn-link" on:click="{ clearDate }">clear</button>
            {/if}
        </div>
    {/if}
</div>

<style>
    .calendar-control {
        width: 270px;
        font-size: 0.8rem;
        color: #333;
        background: #fff;
        border: 1px solid #dddddd;
        border-radius: 3px;
        padding: 5px;
    }

    .calendar-control .heading {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: #000000;
        margin-bottom: 5px;
    }

    .calendar-control .heading .month-nav {
        line-height: 1;
        padding: 5px;
        cursor: pointer;
    }

    .calendar-control .heading .month-nav:hover {
        background: #eeeeee;
    }

    .calendar-control .heading .title {
        font-weight: 500;
    }

    .calendar-control .heading .title .title-link {
        cursor: pointer;
        padding: 5px 0;
    }

    .calendar-control .heading .title .title-link:hover {
        background: #eeeeee;
    }

    .calendar-control .body {
        color: #99b2d8;
    }

    .calendar-control .body:after {
        content: "";
        clear: both;
        display: table;
    }

    .calendar-control .footer {
        text-align: center;
    }

    .calendar-control .weekday {
        display: flex;
        float: left;
        width: 14.285714%;
        font-weight: 500;
        color: #333;
        padding: 5px;
        align-items: center;
        justify-content: center;
    }

    .calendar-control .day {
        display: flex;
        align-items: center;
        justify-content: center;
        float: left;
        width: 14.285714%;
        color: #c2a599;
        border-radius: 3px;
        padding: 6px 0;
        cursor: pointer;
    }

    .calendar-control .day:hover {
        background: #eeeeee;
    }

    .calendar-control .day.active {
        color: #333333;
    }

    .calendar-control .day.selected {
        color: #fff;
        background: #357ebd;
    }

    .calendar-control .month-selector {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        border-bottom: 1px solid #ddd;
    }

    .calendar-control .year-selector {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        border-bottom: 1px solid #ddd;
    }
</style>